import { useMemo } from "react";
import { useSelector } from "react-redux";

import { menuItemsPermission } from "../constants/permissions/menuItemsPermission";
import MENU_ITEMS from "../configs/menuItems";
import { getAuthPolicySelector } from "../modules/App/state/selectors";

const useFirstModulePath = () => {
    const authPolicyCodes = useSelector(getAuthPolicySelector);

    return useMemo(
        () => {
            const firstModulePermissionCode =
                Object.values(menuItemsPermission).find((code) => authPolicyCodes.some((item) => code === item));

            const menuCompare = MENU_ITEMS.reduce(
                (acc, item) => {
                    if(item.subMenu) {
                        acc.push(...item.subMenu);
                    } else {
                        acc.push(item);
                    }

                    return acc;
                },
                []
            );

            const menuItem = menuCompare.find((item) => {
                if(Array.isArray(item.permission)) {
                    return item.permission.indexOf(firstModulePermissionCode) !== -1;
                }

                return item.permission === firstModulePermissionCode;
            });

            return menuItem?.path;
        },
        [ authPolicyCodes ]
    );
};

export default useFirstModulePath;
